import moment from "moment";
import { WorkOrderGeneralSettings } from "~/workorder/types";

const validateTime = (time: string): boolean => {
    if (!time || typeof time !== 'string') {
        return false;
    }
    const parts = time.trim().split(':');
    if (parts.length < 2) {
        return false;
    }
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    return (
        !isNaN(hours) &&
        !isNaN(minutes) &&
        hours >= 0 &&
        hours <= 23 &&
        minutes >= 0 &&
        minutes <= 59
    );
};

const applyTimeToMoment = (m: moment.Moment, time: string): moment.Moment => {
    const [hh, mm] = time.split(':').map((part) => parseInt(part, 10));
    return m.clone().hours(hh).minutes(mm).seconds(0).milliseconds(0);
};

export const hasValidWorkOrderHoursCount = (hoursCount: number): boolean => {
    return hoursCount != null && !isNaN(Number(hoursCount)) && Boolean(hoursCount);
};

export const computePlannedStartEnd = (
    baseDate: moment.MomentInput,
    settings: WorkOrderGeneralSettings,
): { plannedStartDate: string; plannedEndDate: string } => {

    const startTime = settings.plannedStartDate;
    const endTime = settings.plannedEndDate;
    const base = moment(baseDate);
    let start = base.clone();
    let end = base.clone();

    if (hasValidWorkOrderHoursCount(settings.hoursCount)) {
        if (startTime && validateTime(startTime)) {
            start = applyTimeToMoment(start, startTime);
        }
        end = start.clone().add(Number(settings.hoursCount) * 60, 'minutes');
    } else if (
        startTime &&
        endTime &&
        validateTime(startTime) &&
        validateTime(endTime)
    ) {
        start = applyTimeToMoment(start, startTime);
        end = applyTimeToMoment(end, endTime);
    } else {
        start = base.clone();
        end = base.clone().add(60, 'minutes');
    }

    return {
        plannedStartDate: start.format('YYYY-MM-DD[T]HH:mm'),
        plannedEndDate: end.format('YYYY-MM-DD[T]HH:mm'),
    };
};